<template>
  <div class="hydrogen-projects-chart-wrapper">
    <div class="title">
      Data for
      <span style="font-weight: 600">{{ data.totalProjects }}</span> projects
    </div>
    <div v-if="data.data.length > 0">
      <div v-for="chart in data.data" :key="chart.id">
        <Chart v-if="chart.show" :options="options(chart)" />
        <div v-else class="no-data"></div>
      </div>
    </div>
    <div v-else class="no-data">Toggle filter to show chart</div>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";

export default {
  components: {
    Chart,
  },
  props: {
    data: {
      required: false,
    },
    colors: {
      required: false,
    },
  },
  methods: {
    options(item) {
      const { colors } = this;
      return {
        chart: {
          type: "column",
          backgroundColor: "transparent",
          height: 180,
          width: 160,
          styledMode: true,
        },
        plotOptions: {
          column: {
            stacking: item.id === "leProduction" ? "normal" : null,
            dataLabels: {
              allowOverlap: true,
              enabled: true,
              pointFormat: "{point.y:,.0f}",
              formatter: function () {
                if (Number(this.y.toFixed(0)) === 0) {
                  return;
                }
                return `${this.y.toFixed(0)}`;
              },
            },
          },
        },
        title: {
          text: null,
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        yAxis: {
          visible: false,
        },
        xAxis: {
          categories: [`${item.label} (${item.unit})`],
        },
        tooltip: {
          enabled: item.id === "capacity" ? false : true,
          valueDecimals: 2,
          borderColor: null,
          style: {
            fontSize: "0.5em",
          },
          formatter: function () {
            return `<span style="color:${
              colors[this.series.name].color
            }; font-size: 0.8empx;">${this.series.name}</span>`;
          },
        },
        series:
          item.id === "capacity"
            ? item.series
            : item.series.map((d, i) => ({
                ...d,
                ...(i === 0 && {
                  dataLabels: {
                    y: -10,
                  },
                }),
              })),
      };
    },
  },
};
</script>

<style>
.hydrogen-projects-chart-wrapper .title {
  font-size: 0.875rem;
  text-align: center;
}
.hydrogen-projects-chart-wrapper .no-data {
  font-size: 0.875rem;
  text-align: center;
  color: red;
  padding: 20px 10px;
}
</style>
